var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin logo",
    clipPath: "url(#clip0_2069_869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.79624 17.0669V5.93436H1.02292V17.0669H4.79624ZM2.91007 4.4135C4.22589 4.4135 5.04493 3.55865 5.04493 2.49038C5.02041 1.39801 4.22594 0.566895 2.93504 0.566895C1.64433 0.566895 0.800293 1.39803 0.800293 2.49038C0.800293 3.5587 1.61913 4.4135 2.88543 4.4135H2.90995H2.91007ZM6.88476 17.0669H10.6581V10.8499C10.6581 10.5172 10.6826 10.1848 10.7822 9.94699C11.055 9.28222 11.6759 8.59371 12.7182 8.59371C14.0836 8.59371 14.6299 9.6146 14.6299 11.1111V17.0668H18.403V10.6835C18.403 7.26405 16.5414 5.673 14.0588 5.673C12.0232 5.673 11.1295 6.78876 10.633 7.5487H10.6582V5.93413H6.88485C6.93437 6.97874 6.88485 17.0666 6.88485 17.0666L6.88476 17.0669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2069_869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6,
    height: 16.5,
    fill: "white",
    transform: "translate(0.800293 0.566895)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.dea87ed3bb0425578e44f28f8a63dcd8.svg";
export { ForwardRef as ReactComponent };